import { useQuery } from "@tanstack/react-query";

import { getAllUserVerificationFarmTasks } from "services";

import { getFarmIdFromLocalStorage, useGetFarmReportingYear, useGetFarms } from "utils";

import { DEFAULT_CACHE_TIME, GET_ALL_USER_VERIFICATION_FARM_TASKS } from "consts";

import { VerificationsFarmTasks } from "models";

export const useGetAllUserVerificationFarmTasks = (farmId?: string) => {
  const farmIdLocalStorage = getFarmIdFromLocalStorage();
  const { currentFarm } = useGetFarms();
  const {
    data: { activeFarmReportingYear: reportingYear },
  } = useGetFarmReportingYear(farmId ?? currentFarm?.id ?? null);

  return useQuery<VerificationsFarmTasks[]>({
    queryKey: [GET_ALL_USER_VERIFICATION_FARM_TASKS, farmId ?? farmIdLocalStorage, reportingYear],
    queryFn: () => getAllUserVerificationFarmTasks({ farmId: farmId ?? farmIdLocalStorage, createdInYear: reportingYear }),
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
    enabled: !!reportingYear,
  });
};
